import homeTpl from './views/manage-list.html';
import homeCtrl from './controllers/managelistController';

var module = angular.module('ManageReportsModule', [
    //import modules
])
.controller('manageReportCards', homeCtrl);

import './manageReportsModule.scss';
import templateProperty from './views/subject-property.html';
//import homeFctr from './services/homeFactory';
//import userSrv from './services/userService'

//module.service('homeFactory', homeFctr);
//module.service('userService', userSrv);


// module.config(function($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('manageReportCards', {
//             parent: 'app',
//             url: '/manage-report-cards',
//             views: {
//                 '@': {
//                     template: homeTpl,
//                     controller: homeCtrl,
//                     controllerAs: 'manageReportCardsCtrl'
//                 }
//             }
//         })

// });



// WEBPACK FOOTER //
// ./src/app/report_cards/manage_reports/manageReportsModule.js